import { Box, Typography } from '@mui/material'
import show from 'assets/branch/setting/AppointmentSharing.png'
import notShow from 'assets/branch/setting/noAppointmentSharing.png'
import { APPOINTMENT_SHARING } from 'constants/status'
import { useTranslation } from 'react-i18next'

const OpShowAppointmentSharing = () => {
    const { t } = useTranslation()
    const optionCalAdvance = [
        {
            name: t('BRANCH.TAB.SENTTING.PATTERN_APPOINTMENT_SHARING.SHOW'), value: APPOINTMENT_SHARING.SHOW,
            component: <AppointmentSharing showType='1' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.PATTERN_APPOINTMENT_SHARING.NOT_SHOW'), value: APPOINTMENT_SHARING.NOT_DISPLAYED,
            component: <AppointmentSharing showType='0' />,
        }
    ]
    return (optionCalAdvance)
}

export default OpShowAppointmentSharing

interface ShowAppointmentSharingProps {
    showType: '0' | '1'
}
const AppointmentSharing = (props: ShowAppointmentSharingProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={showType === '0' ? '0px' : '16px'}>
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom={showType === '1' ? '0px' : '8px'}>
                    {t('BRANCH.TAB.SENTTING.APPOINTMENT_SHARING')}
                </Typography>
            </Box>
            <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'} >
                <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                    <img src={showType === '0' ? notShow : show} alt="" />
                </Box>
            </Box>
            {/* <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.PATTERN_APPOINTMENT_SHARING.${showType === '1' ? 'SHOW' : 'NOT_SHOW'}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t(`BRANCH.TAB.SENTTING.PATTERN_APPOINTMENT_SHARING.${showType === '1' ? 'SUB_PATTERN' : 'NOT_SUB_PATTERN'}`)}
                </Typography>
            </Box> */}
        </Box>
    )
}